import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../../constants/constants";
import svgIcons from "../../assets/svg/svgIcons";

interface HeaderViewProps {
  title: string;
  showBackButton?: boolean;
  backButtonCallback?: () => void;
  // showRefreshButton?: boolean;
  wrapperClassName?: string;
}

const HeaderView: FC<HeaderViewProps> = ({
  title,
  showBackButton = false,
  backButtonCallback,
  // showRefreshButton = true,
  wrapperClassName = `flex justify-between ${APP_CONFIG.DES.DASH.P_HORIZ} py-2`,
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "admins" });
  const navigate = useNavigate();

  return (
    <header className={wrapperClassName}>
      <div className="flex items-center w-full">
        {showBackButton && (
          <button
            type="button"
            className="mr-4"
            onClick={() => {
              if (!!backButtonCallback) backButtonCallback();
              else navigate(-1)
            }}
          >
            <img
              src={svgIcons.LeftArrowIcon}
              alt="left-arrow-icon"
              className="p-2 bg-accent-blue-pale rounded-full"
            />
          </button>
        )}
        <h1 className="font-bold text-accent-blue-dark text-2xl leading-9">
          {title}
        </h1>
      </div>
    </header>
  )
}

export default HeaderView;